import { render, staticRenderFns } from "./Published.vue?vue&type=template&id=38fc860c&"
import script from "./Published.vue?vue&type=script&lang=js&"
export * from "./Published.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports